import React, { Component } from "react";

import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { addToCart, removeFromCart } from "../../Redux/Actions/actions";
import ShoppingList from "../../Components/ShoppingList/shoppingList";

import "./shoppingcart.css";

class Shoppingcart extends Component {
  render() {
    return (
      <div>
        <h1 className="shoppingCart-Title"> Shopping Cart </h1>
        <ShoppingList
          cartItems={this.props.addedItems}
          addToCart={this.props.addToCart}
          removeFromCart={this.props.removeFromCart}
        />
        <div className="shoppingCart-Footer">
          <div className="shoppingCart-Buttons">
            <Link to="/shop">Continue Shopping</Link>
            {console.log("The cart items are ", this.props.cartItems)}
            {this.props.total !== 0 ?

              <Link to="/shippingdetails">Checkout Order</Link>
              : <Link className="disabled-Checkout-Button" to="/shoppingcart"> Checkout Order </Link>
            }
          </div>
          <div className="shoppingCart-Total">
            <h2> Total: ${this.props.total.toFixed(2)} </h2>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    addedItems: state.CartReducer.addedItems,
    total: state.CartReducer.total,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (id) => {
      dispatch(addToCart(id));
    },
    removeFromCart: (id) => {
      dispatch(removeFromCart(id));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Shoppingcart);
